import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getVideos } from "./videosApi";

const initialState = {
  videos: [],
  isLoding: false,
  isError: false,
  error: "",
};

export const fetchVideos = createAsyncThunk(
  "videos/fetchVideos",
  async ({ tags, search, no }) => {
    const videos = getVideos({ tags, search, no });
    return videos;
  }
  // const res=await
);

const videosSlice = createSlice({
  name: "videos",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchVideos.pending, (state) => {
        state.isError = false;
        state.isLoding = true;
      })
      .addCase(fetchVideos.fulfilled, (state, action) => {
        state.isLoding = false;
        state.videos = action.payload;
      })
      .addCase(fetchVideos.rejected, (state, action) => {
        state.isLoding = false;
        state.videos = [];
        state.isError = true;
        state.error = action.error.message;
      });
  },
});

export default videosSlice.reducer;
